export const TEST_ID = 'warningIcon';
